<template>
    <section id="wrapper-custom-email">
        <cm-back
            sectionTitle="Manage email"
            :contentName="meetup ? meetup.name : 'Loading...'"
            action="true"
        ></cm-back>

        <div class="container mt-3">
            <div class="row d-flex justify-content-center flex-column align-items-center">
                <div class="container-page px-2">
                    <div class="email-reminder-box">
                        <div class="group d-flex flex-wrap flex-md-nowrap align-items-center">
                            <div class="col-12 col-md-6">
                                <div class="title">Reminder Email</div>
                                <div class="subtitle">48H Before the meetup</div>
                            </div>
                            <div class="mx-2 col-md-3">
                                <md-radio
                                    v-model="reminderEmail"
                                    value="active"
                                    :disabled="meetup.status !== 'published'"
                                >Active</md-radio>
                            </div>
                            <div class="mx-2 col-md-3">
                                <md-radio
                                    v-model="reminderEmail"
                                    value="disabled"
                                    :disabled="meetup.status !== 'published'"
                                >Disabled</md-radio>
                            </div>
                        </div>
                        <div class>
                            <button
                                class="btn btn-outline-success justify-content-center d-flex align-items-center mb-sm-0 mb-3"
                                :disabled="loading || loadingReminder || meetup.status !== 'published'"
                                @click="saveReminder()"
                            >
                                <b-spinner
                                    small
                                    label="Loading..."
                                    class="mr-2"
                                    variant="primary"
                                    v-if="loadingReminder"
                                ></b-spinner>SAVE
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container mt-3">
            <div class="row d-flex justify-content-center flex-column align-items-center">
                <div class="create-edit-meetups px-3">
                    <div class="form-block">
                        <h3 class="d-none d-lg-block">
                            Name
                            <span class="require-mark">*</span>
                        </h3>
                        <div class="fields-container first-step">
                            <div class="w-100 d-flex flex-column flex-md-row">
                                <div class="md-layout-item pr-md-3">
                                    <md-field class="name" :class="getValidationClass('name')">
                                        <label for="email-name">Name</label>
                                        <md-input
                                            id="email-name"
                                            name="email-name"
                                            v-model="emailForm.name"
                                        ></md-input>
                                        <span
                                            class="md-error"
                                            v-if="!$v.emailForm.name.required"
                                        >Name is required</span>
                                    </md-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-block">
                        <h3 class="d-none d-lg-block">
                            Reply-To email
                            <span class="require-mark">*</span>
                        </h3>
                        <div class="fields-container first-step">
                            <div class="w-100 d-flex flex-column flex-md-row">
                                <div class="md-layout-item pr-md-3">
                                    <md-field class="name" :class="getValidationClass('replyTo')">
                                        <label for="emails-replyTo">Reply to</label>
                                        <md-input
                                            id="emails-replyTo"
                                            name="emails-replyTo"
                                            v-model="emailForm.replyTo"
                                        ></md-input>
                                        <span
                                            class="md-error"
                                            v-if="!$v.emailForm.replyTo.required"
                                        >Reply To is required</span>
                                        <span
                                            class="md-error"
                                            v-else-if="!$v.emailForm.replyTo.email"
                                        >Reply To must be a valid email</span>
                                    </md-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-block">
                        <h3 class="d-none d-lg-block">
                            Send To
                            <span class="require-mark">*</span>
                        </h3>
                        <div class="fields-container first-step">
                            <div class="w-100 d-flex flex-column flex-md-row">
                                <div class="md-layout-item pr-md-3">
                                    <md-field class="name">
                                        <label for="email-to">To</label>
                                        <md-select id="email-to" name="email-to" v-model="to">
                                            <md-option value="all">To all attendees</md-option>
                                            <md-option
                                                value="checkin"
                                                :disabled="!isPast"
                                            >Only to checked-in users</md-option>
                                        </md-select>
                                    </md-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-block">
                        <h3 class="d-none d-lg-block">
                            Subject
                            <span class="require-mark">*</span>
                        </h3>
                        <div class="fields-container first-step">
                            <div class="w-100 d-flex flex-column flex-md-row">
                                <div class="md-layout-item pr-md-3">
                                    <md-field class="name" :class="getValidationClass('subject')">
                                        <label for="email-subject">Subject</label>
                                        <md-input
                                            id="email-subject"
                                            name="email-subject"
                                            v-model="emailForm.subject"
                                        ></md-input>
                                        <span
                                            class="md-error"
                                            v-if="!$v.emailForm.subject.required"
                                        >Reply To is required</span>
                                    </md-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-block">
                        <h3 class="d-none d-lg-block">
                            Message
                            <span class="require-mark">*</span>
                        </h3>
                        <div class="fields-container first-step">
                            <div class="w-100 d-flex flex-column flex-md-row">
                                <div class="md-layout-item pr-md-3">
                                    <md-field class="name" :class="getValidationClass('message')">
                                        <label
                                            for="email-message"
                                        >A message from {{community.name}} for {{meetup.name}}</label>
                                        <md-textarea
                                            id="email-message"
                                            name="email-message"
                                            v-model="emailForm.message"
                                        ></md-textarea>
                                        <span
                                            class="md-error"
                                            v-if="!$v.emailForm.message.required"
                                        >Message is required</span>
                                    </md-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="fields-container first-step mb-3">
                        <div class="w-100 d-flex flex-column flex-md-row">
                            <div class="md-layout-item pr-md-3">
                                <md-checkbox
                                    id="email-requireInfo"
                                    name="email-requireInfo"
                                    v-model="emailForm.includeInfo"
                                >Include meetup details</md-checkbox>
                            </div>
                        </div>
                    </div>

                    <md-dialog-alert
                        :md-fullscreen="false"
                        class="alert-modal"
                        :md-active.sync="showUpdateResult"
                        md-title="Result"
                        :md-content="updateResultMessage"
                    />

                    <md-dialog-confirm
                        :md-active.sync="sendConfirm"
                        :md-fullscreen="false"
                        md-title="Are you sure?"
                        md-content="Are you sure do you want to send this email to selected attendees"
                        md-confirm-text="Yes. Send it."
                        md-cancel-text="No, I changed my mind."
                        @md-cancel="sendConfirm = false"
                        @md-confirm="sendEmail"
                    />
                    <md-dialog-confirm
                        :md-active.sync="sendConfirmTest"
                        :md-fullscreen="false"
                        md-title="Are you sure?"
                        md-content="Are you sure do you want to send this test email"
                        md-confirm-text="Yes. Send it."
                        md-cancel-text="No, I changed my mind."
                        @md-cancel="sendConfirmTest = false"
                        @md-confirm="sendTestEmail"
                    />
                </div>
            </div>
        </div>
        <div class="actions-container">
            <div class="d-flex flex-column flex-sm-row px-sm-3 align-items-center">
                <div class="w-25 d-flex flex-column flex-md-row">
                    <div class="md-layout-item pr-md-3">
                        <md-field class="name" :class="getTestValidationClass()">
                            <label for="email-subject">Email test</label>
                            <md-input id="email-test" name="email-test" v-model="testTo"></md-input>
                            <span class="md-error" v-if="!$v.testTo.required">Email test is required</span>
                            <span
                                class="md-error"
                                v-if="!$v.testTo.email"
                            >Email test must be a valid email</span>
                        </md-field>
                    </div>
                </div>
                <button
                    class="btn btn-outline-success justify-content-center d-flex align-items-center mb-sm-0 mb-3"
                    @click="sendConfirmTest = isTestOk()"
                    :disabled="loading"
                >
                    <b-spinner
                        small
                        label="Loading..."
                        class="mr-2"
                        variant="primary"
                        v-if="loading"
                    ></b-spinner>SEND TEST
                </button>

                <button
                    class="btn ml-sm-3 btn-primary justify-content-center d-flex align-items-center mt-sm-0 mt-3"
                    @click="sendConfirm = isFormOk()"
                    :disabled="loading"
                >
                    <b-spinner small label="Loading..." class="mr-2" variant="light" v-if="loading"></b-spinner>SEND NOW
                </button>
            </div>
        </div>
    </section>
</template>
<script>
import { validationMixin } from "vuelidate";
import {
    required,
    minValue,
    maxValue,
    minLength,
    maxLength,
    email
} from "vuelidate/lib/validators";
import { isAfter, parseISO } from "date-fns";
import CmBack from "@/components/CmBack.vue";

export default {
    name: "ManageMeetupEmail",

    components: {
        CmBack
    },

    data: () => ({
        emailForm: {
            name: "",
            replyTo: "",
            subject: "",
            message: "",
            includeInfo: true
        },
        testTo: "",
        to: "all",
        sendConfirm: false,
        sendConfirmTest: false,
        updateResultMessage: "",
        showUpdateResult: false,
        loading: false,
        reminderEmail: "disabled",
        loadingReminder: false
    }),
    mixins: [validationMixin],
    computed: {
        community() {
            return this.$store.getters.community;
        },
        meetup() {
            return this.$store.getters.meetup || {};
        },
        isPast() {
            return isAfter(
                new Date(),
                parseISO(this.meetup.end_datetime + "Z")
            );
        }
    },
    validations: {
        emailForm: {
            name: required,
            replyTo: {
                required,
                email
            },
            subject: required,
            message: required
        },
        testTo: {
            required,
            email
        }
    },
    async mounted() {
        this.loading = true;
        if (!this.community) {
            this.$store.commit(
                "setCommunity",
                await this.$communityApi.getCommunity(this.$route.params.id)
            );
        }
        if (!this.meetup.id) {
            this.$store.commit(
                "setMeetup",
                (
                    await this.$meetupApi.getMeetupById(
                        this.$route.params.meetupid
                    )
                ).data
            );
        }
        this.emailForm.name = this.community.name;
        this.emailForm.subject = `Message to attendees of ${this.meetup.name}`;
        this.loading = false;
        this.reminderEmail = this.meetup.reminder ? "active" : "disabled";
    },
    methods: {
        getValidationClass(fieldName) {
            const field = this.$v.emailForm[fieldName];
            if (field) {
                return {
                    "md-invalid": field.$invalid && field.$dirty
                };
            }
        },
        getTestValidationClass() {
            const field = this.$v.testTo;
            if (field) {
                return {
                    "md-invalid": field.$invalid && field.$dirty
                };
            }
        },
        isFormOk() {
            this.$v.emailForm.$touch();
            if (!this.$v.emailForm.$invalid) {
                return true;
            } else {
                this.updateResultMessage =
                    "There are some errors. Check the form.";
                this.showUpdateResult = true;
                return false;
            }
        },
        isTestOk() {
            if (this.isFormOk()) {
                this.$v.testTo.$touch();
                if (!this.$v.testTo.$invalid) {
                    return true;
                } else {
                    this.updateResultMessage =
                        "There are some errors. Check the form.";
                    this.showUpdateResult = true;
                    return false;
                }
            }
            return false;
        },
        async sendEmail() {
            if (!this.isFormOk()) return;
            this.loading = true;
            try {
                await this.$meetupApi.sendCustomEmail(
                    this.meetup.id,
                    this.emailForm,
                    this.to === "checkin"
                );
                this.updateResultMessage = "Email sent to selected attendees";
                this.showUpdateResult = true;
            } catch (error) {
                this.updateResultMessage =
                    "There are some errors: " + error.message;
                this.showUpdateResult = true;
            } finally {
                this.loading = false;
            }
        },
        async sendTestEmail() {
            if (!this.isTestOk()) return;
            this.loading = true;
            try {
                await this.$meetupApi.sendCustomEmailTest(
                    this.meetup.id,
                    this.emailForm,
                    this.testTo
                );
                this.updateResultMessage = "Test Email sent to " + this.testTo;
                this.showUpdateResult = true;
            } catch (error) {
                this.updateResultMessage =
                    "There are some errors: " + error.message;
                this.showUpdateResult = true;
            } finally {
                this.loading = false;
            }
        },
        async saveReminder() {
            this.loadingReminder = true;
            try {
                switch (this.reminderEmail) {
                    case "active":
                        await this.$meetupApi.activateReminder(this.meetup.id);
                        this.updateResultMessage = "Reminder activated";
                        this.showUpdateResult = true;
                        break;
                    case "disabled":
                        await this.$meetupApi.deactivateReminder(
                            this.meetup.id
                        );
                        this.updateResultMessage = "Reminder disabled";
                        this.showUpdateResult = true;
                        break;
                    default:
                        break;
                }
            } catch (error) {
                this.updateResultMessage = error.message;
                this.showUpdateResult = true;
            } finally {
                this.loadingReminder = false;
            }
        }
    }
};
</script>
<style lang="scss">
.md-menu-content,
.md-datepicker-dialog {
    z-index: 1032 !important;
}
.alert-modal {
    z-index: 1050 !important;
}
.v-note-wrapper {
    z-index: 5 !important;
    min-width: 240px !important;
    &.fullscreen {
        margin-top: 115px !important;
        z-index: 1050 !important;
    }
}
.second-step {
    .md-field > .md-icon:after {
        height: 0 !important;
    }
}
.op-image.popup-dropdown .dropdown-item:last-of-type {
    display: none;
}
.third-step {
    .croppa-container canvas {
        width: auto !important;
        height: auto !important;
    }
}
</style>
<style lang="scss" scoped>
@import "@/assets/scss/_common.scss";
#wrapper-custom-email {
    background-color: #f9f9f9;
    .wrap-title-breadscrumbs {
        line-height: 1.2;
    }
}
.container-page {
    width: 100%;
    max-width: 915px;
}
.email-reminder-box {
    background: #fff;
    border-radius: 5px;
    padding: 12px;
    margin: 5px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #e4e4ea;

    .title {
        font-weight: bold;
    }

    .subtitle {
        font-size: 0.8em;
    }

    .group {
        display: flex;
    }
}

.actions-container {
    &.sticky {
        position: sticky;
        bottom: 0;
        z-index: 15;
    }
    width: 100%;
    padding: 15px;
    border-top: 1px solid #e6e6e6;
    background: white;
    & > div {
        max-width: 915px;
        margin: auto;
        justify-content: flex-end;
    }
}
.create-edit-meetups {
    width: 100%;
    max-width: 915px;

    .form-block {
        width: 100%;
        padding-bottom: 20px;
        input {
            margin-top: 10px;
        }
        @media all and (min-width: $size-tablet-landscape) {
            display: flex;
            max-width: 100%;
            & > h3 {
                padding-right: 15px;
            }
        }
        h3 {
            text-align: left;
            font-size: 16px;
            padding-bottom: 10px;
            margin-top: 10px;
            border-bottom: 0px solid #e4e4ea;
            @media all and (min-width: $size-tablet-landscape) {
                width: 20%;
                border: none;
                border-right: 2px solid #e4e4ea;
                margin: 0;
                padding: 10px 0;
            }
        }
    }

    .fields-container {
        display: flex;
        flex-direction: column;
        padding-top: 5px;
        @media all and (min-width: $size-tablet-landscape) {
            padding-left: 25px;
            width: 80%;
        }

        h3 {
            margin-left: 20px;
            border: none;
            small {
                display: block;
            }
        }
    }

    .md-button {
        font-weight: 600 !important;
    }

    input::placeholder {
        color: #575757 !important;
    }
    .first-step {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .seats {
            input {
                width: 100%;
            }
        }

        .md-field {
            margin-bottom: 0;
            &.md-invalid {
                margin-bottom: 18px;
            }
        }

        .inputs {
            width: 100%;
            @media all and (min-width: $size-large-portrait) {
                width: 50%;
                padding-right: 25px;
            }
            input {
                width: 100%;
            }
        }
        iframe.show-map {
            display: block !important;
            width: 100%;
            height: 199px;
        }
        p.show-map {
            color: $palette-orange;
            cursor: pointer;
            width: 100%;
            margin-top: 15px;
            @media all and (min-width: $size-large-portrait) {
                display: none;
            }
        }
        iframe {
            display: none;
            height: 224px;
            @media all and (min-width: $size-large-portrait) {
                display: block;
                width: 100%;
                padding-top: 25px;
            }
        }
        span {
            display: flex;
            :first-child {
                margin-right: 10px;
            }
        }
    }

    .googlemaps #placeholder {
        font-weight: 500 !important;
    }

    .md-field .md-input::-webkit-input-placeholder,
    .md-field .md-textarea::-webkit-input-placeholder {
        font-weight: 500 !important;
    }
}
</style>